import React from 'react'
import './Step.css'

const Step = (props) => (
  <div className='step'>{props.value}</div>
)

export default Step
